<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Jam Kerja</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Jam Kerja</li>
                </ul>
              </div>
              <div v-if="safeBackPath" class="col-auto float-right ml-auto">
                <button type="button" class="btn btn-outline-primary" :disabled="saving" @click="goBack">
                  <i v-if="saving" class="fa fa-spinner fa-spin"></i>
                  <i v-else class="fa fa-arrow-left"></i>
                  Kembali
                </button>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="row">
            <div class="col-md-12">
              <!-- {{currentDateTimeUnix()}} -->
              <!-- {{form}} -->
              <div class="table-responsive">
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th>Hari</th>
                      <th>Jam Buka</th>
                      <th>Jam Tutup</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr>
                        <td colspan="5">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template>
                      <tr>
                        <td>Senin</td>
                        <td>
                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_monday_start_hour"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="hour in 23"
                              :key="hour"
                              :value="(hour<10)?'0'+hour:hour"
                            >{{(hour<10)?'0'+hour:hour}}</option>
                          </select>

                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_monday_start_minute"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="minute in 59"
                              :key="minute"
                              :value="(minute<10)?'0'+minute:minute"
                            >{{(minute<10)?'0'+minute:minute}}</option>
                          </select>
                        </td>
                        <td>
                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_monday_end_hour"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="hour in 23"
                              :key="hour"
                              :value="(hour<10)?'0'+hour:hour"
                            >{{(hour<10)?'0'+hour:hour}}</option>
                          </select>

                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_monday_end_minute"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="minute in 59"
                              :key="minute"
                              :value="(minute<10)?'0'+minute:minute"
                            >{{(minute<10)?'0'+minute:minute}}</option>
                          </select>
                        </td>
                        <td>
                          <div class="form-group">
                            <div class="onoffswitch">
                              <input
                                type="checkbox"
                                name="onoffswitch"
                                v-model="form.wh_monday_status"
                                class="onoffswitch-checkbox"
                                id="wh_monday_status"
                                @change="storeWorkingHours"
                              />
                              <label class="onoffswitch-label" for="wh_monday_status">
                                <span class="onoffswitch-inner"></span>
                                <span class="onoffswitch-switch"></span>
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Selasa</td>
                        <td>
                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_tuesday_start_hour"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="hour in 23"
                              :key="hour"
                              :value="(hour<10)?'0'+hour:hour"
                            >{{(hour<10)?'0'+hour:hour}}</option>
                          </select>

                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_tuesday_start_minute"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="minute in 59"
                              :key="minute"
                              :value="(minute<10)?'0'+minute:minute"
                            >{{(minute<10)?'0'+minute:minute}}</option>
                          </select>
                        </td>
                        <td>
                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_tuesday_end_hour"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="hour in 23"
                              :key="hour"
                              :value="(hour<10)?'0'+hour:hour"
                            >{{(hour<10)?'0'+hour:hour}}</option>
                          </select>

                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_tuesday_end_minute"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="minute in 59"
                              :key="minute"
                              :value="(minute<10)?'0'+minute:minute"
                            >{{(minute<10)?'0'+minute:minute}}</option>
                          </select>
                        </td>
                        <td>
                          <div class="form-group">
                            <div class="onoffswitch">
                              <input
                                @change="storeWorkingHours"
                                type="checkbox"
                                name="onoffswitch"
                                v-model="form.wh_tuesday_status"
                                class="onoffswitch-checkbox"
                                id="wh_tuesday_status"
                              />
                              <label class="onoffswitch-label" for="wh_tuesday_status">
                                <span class="onoffswitch-inner"></span>
                                <span class="onoffswitch-switch"></span>
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Rabu</td>
                        <td>
                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_wednesday_start_hour"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="hour in 23"
                              :key="hour"
                              :value="(hour<10)?'0'+hour:hour"
                            >{{(hour<10)?'0'+hour:hour}}</option>
                          </select>

                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_wednesday_start_minute"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="minute in 59"
                              :key="minute"
                              :value="(minute<10)?'0'+minute:minute"
                            >{{(minute<10)?'0'+minute:minute}}</option>
                          </select>
                        </td>
                        <td>
                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_wednesday_end_hour"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="hour in 23"
                              :key="hour"
                              :value="(hour<10)?'0'+hour:hour"
                            >{{(hour<10)?'0'+hour:hour}}</option>
                          </select>

                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_wednesday_end_minute"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="minute in 59"
                              :key="minute"
                              :value="(minute<10)?'0'+minute:minute"
                            >{{(minute<10)?'0'+minute:minute}}</option>
                          </select>
                        </td>
                        <td>
                          <div class="form-group">
                            <div class="onoffswitch">
                              <input
                                @change="storeWorkingHours"
                                type="checkbox"
                                name="onoffswitch"
                                v-model="form.wh_wednesday_status"
                                class="onoffswitch-checkbox"
                                id="wh_wednesday_status"
                              />
                              <label class="onoffswitch-label" for="wh_wednesday_status">
                                <span class="onoffswitch-inner"></span>
                                <span class="onoffswitch-switch"></span>
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Kamis</td>
                        <td>
                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_thursday_start_hour"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="hour in 23"
                              :key="hour"
                              :value="(hour<10)?'0'+hour:hour"
                            >{{(hour<10)?'0'+hour:hour}}</option>
                          </select>

                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_thursday_start_minute"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="minute in 59"
                              :key="minute"
                              :value="(minute<10)?'0'+minute:minute"
                            >{{(minute<10)?'0'+minute:minute}}</option>
                          </select>
                        </td>
                        <td>
                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_thursday_end_hour"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="hour in 23"
                              :key="hour"
                              :value="(hour<10)?'0'+hour:hour"
                            >{{(hour<10)?'0'+hour:hour}}</option>
                          </select>

                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_thursday_end_minute"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="minute in 59"
                              :key="minute"
                              :value="(minute<10)?'0'+minute:minute"
                            >{{(minute<10)?'0'+minute:minute}}</option>
                          </select>
                        </td>
                        <td>
                          <div class="form-group">
                            <div class="onoffswitch">
                              <input
                                @change="storeWorkingHours"
                                type="checkbox"
                                name="onoffswitch"
                                v-model="form.wh_thursday_status"
                                class="onoffswitch-checkbox"
                                id="wh_thursday_status"
                              />
                              <label class="onoffswitch-label" for="wh_thursday_status">
                                <span class="onoffswitch-inner"></span>
                                <span class="onoffswitch-switch"></span>
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Jumat</td>
                        <td>
                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_friday_start_hour"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="hour in 23"
                              :key="hour"
                              :value="(hour<10)?'0'+hour:hour"
                            >{{(hour<10)?'0'+hour:hour}}</option>
                          </select>

                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_friday_start_minute"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="minute in 59"
                              :key="minute"
                              :value="(minute<10)?'0'+minute:minute"
                            >{{(minute<10)?'0'+minute:minute}}</option>
                          </select>
                        </td>
                        <td>
                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_friday_end_hour"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="hour in 23"
                              :key="hour"
                              :value="(hour<10)?'0'+hour:hour"
                            >{{(hour<10)?'0'+hour:hour}}</option>
                          </select>

                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_friday_end_minute"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="minute in 59"
                              :key="minute"
                              :value="(minute<10)?'0'+minute:minute"
                            >{{(minute<10)?'0'+minute:minute}}</option>
                          </select>
                        </td>
                        <td>
                          <div class="form-group">
                            <div class="onoffswitch">
                              <input
                                @change="storeWorkingHours"
                                type="checkbox"
                                name="onoffswitch"
                                v-model="form.wh_friday_status"
                                class="onoffswitch-checkbox"
                                id="wh_friday_status"
                              />
                              <label class="onoffswitch-label" for="wh_friday_status">
                                <span class="onoffswitch-inner"></span>
                                <span class="onoffswitch-switch"></span>
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Sabtu</td>
                        <td>
                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_saturday_start_hour"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="hour in 23"
                              :key="hour"
                              :value="(hour<10)?'0'+hour:hour"
                            >{{(hour<10)?'0'+hour:hour}}</option>
                          </select>

                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_saturday_start_minute"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="minute in 59"
                              :key="minute"
                              :value="(minute<10)?'0'+minute:minute"
                            >{{(minute<10)?'0'+minute:minute}}</option>
                          </select>
                        </td>
                        <td>
                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_saturday_end_hour"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="hour in 23"
                              :key="hour"
                              :value="(hour<10)?'0'+hour:hour"
                            >{{(hour<10)?'0'+hour:hour}}</option>
                          </select>

                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_saturday_end_minute"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="minute in 59"
                              :key="minute"
                              :value="(minute<10)?'0'+minute:minute"
                            >{{(minute<10)?'0'+minute:minute}}</option>
                          </select>
                        </td>
                        <td>
                          <div class="form-group">
                            <div class="onoffswitch">
                              <input
                                @change="storeWorkingHours"
                                type="checkbox"
                                name="onoffswitch"
                                v-model="form.wh_saturday_status"
                                class="onoffswitch-checkbox"
                                id="wh_saturday_status"
                              />
                              <label class="onoffswitch-label" for="wh_saturday_status">
                                <span class="onoffswitch-inner"></span>
                                <span class="onoffswitch-switch"></span>
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Minggu</td>
                        <td>
                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_sunday_start_hour"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="hour in 23"
                              :key="hour"
                              :value="(hour<10)?'0'+hour:hour"
                            >{{(hour<10)?'0'+hour:hour}}</option>
                          </select>

                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_sunday_start_minute"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="minute in 59"
                              :key="minute"
                              :value="(minute<10)?'0'+minute:minute"
                            >{{(minute<10)?'0'+minute:minute}}</option>
                          </select>
                        </td>
                        <td>
                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_sunday_end_hour"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="hour in 23"
                              :key="hour"
                              :value="(hour<10)?'0'+hour:hour"
                            >{{(hour<10)?'0'+hour:hour}}</option>
                          </select>

                          <select
                            @change="storeWorkingHours"
                            style="width:50px;"
                            v-model="form.wh_sunday_end_minute"
                          >
                            <option :value="''">--</option>
                            <option :value="'00'">00</option>
                            <option
                              v-for="minute in 59"
                              :key="minute"
                              :value="(minute<10)?'0'+minute:minute"
                            >{{(minute<10)?'0'+minute:minute}}</option>
                          </select>
                        </td>
                        <td>
                          <div class="form-group">
                            <div class="onoffswitch">
                              <input
                                @change="storeWorkingHours"
                                type="checkbox"
                                name="onoffswitch"
                                v-model="form.wh_sunday_status"
                                class="onoffswitch-checkbox"
                                id="wh_sunday_status"
                              />
                              <label class="onoffswitch-label" for="wh_sunday_status">
                                <span class="onoffswitch-inner"></span>
                                <span class="onoffswitch-switch"></span>
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { safeWorkingHoursBackPath } from "@/views/ai/agentV2/workingHours";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton
  },
  data() {
    return {
      isLoading: false,
      isShowModal: false,
      loading: false,
      formOld: {
        id: "",
        member_id: "",
        wh_sunday_status: 0,
        wh_sunday_start: "08:00",
        wh_sunday_start_hour: "08",
        wh_sunday_start_minute: "00",
        wh_sunday_end: "17:00",
        wh_sunday_end_hour: "17",
        wh_sunday_end_minute: "00",
        wh_monday_status: 1,
        wh_monday_start: "08:00",
        wh_monday_start_hour: "08",
        wh_monday_start_minute: "00",
        wh_monday_end: "17:00",
        wh_monday_end_hour: "17",
        wh_monday_end_minute: "00",
        wh_tuesday_status: 1,
        wh_tuesday_start: "08:00",
        wh_tuesday_start_hour: "08",
        wh_tuesday_start_minute: "00",
        wh_tuesday_end: "17:00",
        wh_tuesday_end_hour: "17",
        wh_tuesday_end_minute: "00",
        wh_wednesday_status: 1,
        wh_wednesday_start: "08:00",
        wh_wednesday_start_hour: "08",
        wh_wednesday_start_minute: "00",
        wh_wednesday_end: "17:00",
        wh_wednesday_end_hour: "17",
        wh_wednesday_end_minute: "00",
        wh_thursday_status: 1,
        wh_thursday_start: "08:00",
        wh_thursday_start_hour: "08",
        wh_thursday_start_minute: "00",
        wh_thursday_end: "17:00",
        wh_thursday_end_hour: "17",
        wh_thursday_end_minute: "00",
        wh_friday_status: 1,
        wh_friday_start: "08:00",
        wh_friday_start_hour: "08",
        wh_friday_start_minute: "00",
        wh_friday_end: "17:00",
        wh_friday_end_hour: "17",
        wh_friday_end_minute: "00",
        wh_saturday_status: 0,
        wh_saturday_start: "08:00",
        wh_saturday_start_hour: "08",
        wh_saturday_start_minute: "00",
        wh_saturday_end: "17:00",
        wh_saturday_end_hour: "17",
        wh_saturday_end_minute: "00"
      },
      form: {
        id: "",
        member_id: "",
        wh_sunday_status: 0,
        wh_sunday_start: "08:00",
        wh_sunday_start_hour: "08",
        wh_sunday_start_minute: "00",
        wh_sunday_end: "17:00",
        wh_sunday_end_hour: "17",
        wh_sunday_end_minute: "00",
        wh_monday_status: 0,
        wh_monday_start: "08:00",
        wh_monday_start_hour: "08",
        wh_monday_start_minute: "00",
        wh_monday_end: "17:00",
        wh_monday_end_hour: "17",
        wh_monday_end_minute: "00",
        wh_tuesday_status: 0,
        wh_tuesday_start: "08:00",
        wh_tuesday_start_hour: "08",
        wh_tuesday_start_minute: "00",
        wh_tuesday_end: "17:00",
        wh_tuesday_end_hour: "17",
        wh_tuesday_end_minute: "00",
        wh_wednesday_status: 0,
        wh_wednesday_start: "08:00",
        wh_wednesday_start_hour: "08",
        wh_wednesday_start_minute: "00",
        wh_wednesday_end: "17:00",
        wh_wednesday_end_hour: "17",
        wh_wednesday_end_minute: "00",
        wh_thursday_status: 0,
        wh_thursday_start: "08:00",
        wh_thursday_start_hour: "08",
        wh_thursday_start_minute: "00",
        wh_thursday_end: "17:00",
        wh_thursday_end_hour: "17",
        wh_thursday_end_minute: "00",
        wh_friday_status: 0,
        wh_friday_start: "08:00",
        wh_friday_start_hour: "08",
        wh_friday_start_minute: "00",
        wh_friday_end: "17:00",
        wh_friday_end_hour: "17",
        wh_friday_end_minute: "00",
        wh_saturday_status: 0,
        wh_saturday_start: "08:00",
        wh_saturday_start_hour: "08",
        wh_saturday_start_minute: "00",
        wh_saturday_end: "17:00",
        wh_saturday_end_hour: "17",
        wh_saturday_end_minute: "00"
      },
      saving: false,
      saveChain: null
    };
    //  isactive : true
  },
  computed: {
    safeBackPath() {
      return safeWorkingHoursBackPath(this.$route.query.back);
    }
  },
  watch: {},
  created() {
    this.detailData();
  },
  methods: {
    async detailData() {
      this.loading = true;
      try {
        const response = await this.$store.dispatch("toolkit/detailWorkingHours");
        const data = (response && response.data) || {};
        this.formOld = data;
        this.form = data;
      } catch (error) {
        // Interceptor request sudah menampilkan pesan; form tetap memakai
        // nilai terakhir agar halaman tidak kosong.
      } finally {
        this.loading = false;
      }
    },
    async goBack() {
      if (!this.safeBackPath) return;
      if (this.saveChain) {
        try {
          await this.saveChain;
        } catch (error) {
          // Perubahan terakhir sudah dicoba disimpan; V2 akan memvalidasi ulang
          // jadwal dari API setelah kembali.
        }
      }
      this.$router.push(this.safeBackPath);
    },
    async storeWorkingHours() {
      let formData = await {};
      formData.wh_sunday_status = this.form.wh_sunday_status ? 1 : 0;
      formData.wh_sunday_start =
        this.form.wh_sunday_start_hour + ":" + this.form.wh_sunday_start_minute;
      formData.wh_sunday_end =
        this.form.wh_sunday_end_hour + ":" + this.form.wh_sunday_end_minute;

      formData.wh_monday_status = this.form.wh_monday_status ? 1 : 0;
      formData.wh_monday_start =
        this.form.wh_monday_start_hour + ":" + this.form.wh_monday_start_minute;
      formData.wh_monday_end =
        this.form.wh_monday_end_hour + ":" + this.form.wh_monday_end_minute;

      formData.wh_tuesday_status = this.form.wh_tuesday_status ? 1 : 0;
      formData.wh_tuesday_start =
        this.form.wh_tuesday_start_hour +
        ":" +
        this.form.wh_tuesday_start_minute;
      formData.wh_tuesday_end =
        this.form.wh_tuesday_end_hour + ":" + this.form.wh_tuesday_end_minute;

      formData.wh_wednesday_status = this.form.wh_wednesday_status ? 1 : 0;
      formData.wh_wednesday_start =
        this.form.wh_wednesday_start_hour +
        ":" +
        this.form.wh_wednesday_start_minute;
      formData.wh_wednesday_end =
        this.form.wh_wednesday_end_hour +
        ":" +
        this.form.wh_wednesday_end_minute;

      formData.wh_thursday_status = this.form.wh_thursday_status ? 1 : 0;
      formData.wh_thursday_start =
        this.form.wh_thursday_start_hour +
        ":" +
        this.form.wh_thursday_start_minute;
      formData.wh_thursday_end =
        this.form.wh_thursday_end_hour + ":" + this.form.wh_thursday_end_minute;

      formData.wh_friday_status = this.form.wh_friday_status ? 1 : 0;
      formData.wh_friday_start =
        this.form.wh_friday_start_hour + ":" + this.form.wh_friday_start_minute;
      formData.wh_friday_end =
        this.form.wh_friday_end_hour + ":" + this.form.wh_friday_end_minute;

      formData.wh_saturday_status = this.form.wh_saturday_status ? 1 : 0;
      formData.wh_saturday_start =
        this.form.wh_saturday_start_hour +
        ":" +
        this.form.wh_saturday_start_minute;
      formData.wh_saturday_end =
        this.form.wh_saturday_end_hour + ":" + this.form.wh_saturday_end_minute;
      this.saving = true;
      const previous = this.saveChain || Promise.resolve();
      const task = previous
        .catch(() => {})
        .then(() => this.$store.dispatch("toolkit/storeWorkingHours", formData))
        .catch(() => this.detailData());
      this.saveChain = task.then(
        () => {
          this.saving = false;
        },
        () => {
          this.saving = false;
        }
      );
      await this.saveChain;
    }
  },
  mounted() {},
  name: "working-hours-list"
};
</script>


// WEBPACK FOOTER //
// src/views/toolkit/workingHours/list.vue